// import { useQuery } from "@tanstack/react-query";
// import { useConfig } from "../../../hooks/use-config";
// import { fetchProject, getConversationByProjectId, getConversationByProjectIdPayload } from "../services/projects-services";

// export const useFetchProject = (projectId: string) => {
//     const { configurationSettings } = useConfig();
//     return useQuery({
//         queryKey: ["getProject", projectId],
//         queryFn: () => fetchProject(configurationSettings, projectId),
//         enabled: !!projectId,
//     });
// }

// export const useGetConversationsByProjectId = (payload: getConversationByProjectIdPayload) => {
//     const { configurationSettings } = useConfig();
//     return useQuery({
//         queryKey: ['groupChatParticipants', payload.projectId],
//         queryFn: () => getConversationByProjectId(payload, configurationSettings),
//         enabled: !!payload.projectId,
//     });
// }


import { useMutation, useQuery } from "@tanstack/react-query";
import { useConfig } from "../../../hooks/use-config";
import {
    fetchProject,
    fetchProjectConversations
} from "../services/projects-services";

export const useFetchProject = (projectId: string, options?: { enabled?: boolean }) => {
    const { configurationSettings } = useConfig();

    return useQuery({
        queryKey: ["project", projectId],
        queryFn: () => fetchProject(configurationSettings, projectId),
        enabled: !!projectId && (options?.enabled ?? true),
    });
};

export const useFetchProjectConversations = (projectId: string, options?: { enabled?: boolean }) => {
    const { configurationSettings } = useConfig();

    return useQuery({
        queryKey: ["project-conversations", projectId],
        queryFn: () => fetchProjectConversations(configurationSettings, projectId),
        enabled: !!projectId && (options?.enabled ?? true),
    });
};

/**
 * Combined Hook
 * Returns: project, loading states, and project.items populated
 */
export const useProjectWithConversations = (projectId: string) => {
    const projectQuery = useFetchProject(projectId);
    const conversationsQuery = useFetchProjectConversations(projectId);

    const projectWithItems = projectQuery.data
        ? {
            ...projectQuery.data,
            items: conversationsQuery.data ?? [],
        }
        : null;

    return {
        project: projectWithItems,
        isProjectLoading: projectQuery.isLoading,
        isConversationsLoading: conversationsQuery.isLoading,
        isError: projectQuery.isError || conversationsQuery.isError,
    };
};


export const useFetchProjectConversationsForSidebar = () => {
    const { configurationSettings } = useConfig();

    interface FetchProjectConversationsPayload {
        projectId: string;
    }

    return useMutation({
        mutationKey: ['fetchProjectConversations'],
        mutationFn: (payload: FetchProjectConversationsPayload) =>
            fetchProjectConversations(configurationSettings, payload.projectId),
        gcTime: 0,
    });
};